import { ResponsiveBar } from '@nivo/bar';

interface UserProgressData {
  username: string;
  totalJobs: number;
  completed: number;
  remaining: number;
  progress: number;
  status: string;
}

interface UserProgressBarChartProps {
  data: UserProgressData[];
}

export default function UserProgressBarChart({
  data,
}: UserProgressBarChartProps): JSX.Element {
  const chartData = data.map(user => ({
    user: user.username,
    completed: user.completed,
    remaining: user.remaining,
  }));

  return (
    <ResponsiveBar
      data={chartData}
      keys={['completed', 'remaining']}
      indexBy="user"
      margin={{ top: 20, right: 20, bottom: 40, left: 60 }}
      padding={0.3}
      layout="horizontal"
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={['#10b981', '#e5e7eb']}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Jobs',
        legendPosition: 'middle',
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Users',
        legendPosition: 'middle',
        legendOffset: -50,
      }}
      enableLabel={true}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 12,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      ariaLabel="User progress bar chart"
      theme={{
        labels: {
          text: {
            fill: '#ffffff',
            fontSize: 11,
            fontWeight: 600,
          },
        },
        axis: {
          ticks: {
            text: {
              fill: '#6a7282',
              fontSize: 11,
            },
          },
          legend: {
            text: {
              fill: '#0a0a0a',
              fontSize: 12,
              fontWeight: 600,
            },
          },
        },
      }}
    />
  );
}
